<template>
	<el-row>
		<el-col :span="24">
			<div class="base-form header">				
				<h2>Запчасти</h2>				
				<el-button type="primary" :icon="circleIcon" size="large" @click="onAddItemClick">
					Новая запчасть
				</el-button>
			</div>
		</el-col>
	</el-row>	
	<el-row v-if="isDictionaryModeEnabled">
		<el-col :span="24" style="text-align: left;">
			<div class="base-form" style="width: 100%!important; max-width: unset; display: block;">
				<el-space fill style="width: 80%; min-width: 350px; max-width: 800px;">
					<el-card fill>
						<template #header>
							<el-text type="primary" size="large">
								Выбранные запчасти
								<el-tag type="primary" size="small">{{ selectedItems.length }}</el-tag>
							</el-text>
						</template>
						<el-select style="width: 100%" v-model="selectedItems" multiple clearable placeholder="Запчасти">
							<el-option
								v-for="item in tableSelectedItems"
								:key="item.id"
								:label="item.externalName"
								:value="item.id">
								<div>
									{{ item.externalName }}, {{ item.partNumber }}
								</div>
							</el-option>
							<template #label="{ value }">
								{{ formatSelectedItem(value) }}
							</template>
						</el-select>
						<div style="margin: 1rem 0 0 0">
							<el-button type="primary" @click="onSaveItemsSetClick">Сохранить</el-button>
							<el-button @click="onClearItemsSetClick">Очистить</el-button>
						</div>
					</el-card>
				</el-space>
			</div>
		</el-col>
	</el-row>

	<el-row>
		<el-col :span="6">
			<div class="base-form filter">
				<el-input v-model="tableSearchQuery" style="max-width: 600px" placeholder="Поиск по артикулу, названию, группе и производителю"
					class="input-with-select">
					<template #append>
						<el-button :icon="searchIcon" />
					</template>
				</el-input>
			</div>
		</el-col>
	</el-row>
	<el-row>
		<el-col :span="6">
			<div class="base-form filter">
				<el-select v-model="tableGroupsFilter" multiple placeholder="Фильтр по группам">
					<el-option v-for="e in itemGroups"
						:key="e.id"
						:value="e.id"
						:label="e.name">
					</el-option>
				</el-select>
			</div>
		</el-col>	
		<el-col :span="6">
			<div class="base-form filter">
				<el-select v-model="tableManufacturersFilter" multiple placeholder="Фильтр по производителям">
					<el-option v-for="e in itemManufacturers"
						:key="e.id"
						:value="e.id"
						:label="e.name">
					</el-option>
				</el-select>
			</div>
		</el-col>
	</el-row>
	<el-row>
		<el-col :span="24">
			<el-table ref="tableRef"
				row-key="id" 				
				v-loading="tableLoading"	
				:element-loading-svg="tableLoadingSvg"
				@sort-change="onTableSortingChange"
				@row-click="onTableRowClick"
				:data="tableData"
				:default-sort="{ prop: tableSortColumn, order: tableSortOrder }">
				<el-table-column type="selection" v-if="!isDictionaryModeEnabled" />
				<el-table-column width="45" v-if="isDictionaryModeEnabled">
					<template #default="scope">		
						<el-checkbox :value="scope.row.id" @change="(state) => onItemSelectChange(state, scope.row.id)" />
					</template>
				</el-table-column>
				<el-table-column label="Артикул" sortable prop="partNumber" column-key="partNumber" />
				<el-table-column label="Наименование" sortable prop="externalName" column-key="partNumber" />
				<el-table-column label="Производитель" sortable prop="manufacturer.name" column-key="manufacturer" />
				<el-table-column label="Единица измерения" prop="measureUnit.name" column-key="measureUnit" />
				<el-table-column label="Группа" prop="group.name" sortable column-key="group" />
				<el-table-column width="74" align="right">
					<template #default="scope">		
						<el-button 
							:icon="deleteIcon" 
							type="danger"
							circle
							@click="(e) => onDeleteItemClick(e, scope.row)"
						/>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { CirclePlus, Delete, Search } from '@element-plus/icons-vue';
import { ElButton, ElTable, ElTag, ElLink, ElMessageBox, ElNotification } from 'element-plus';
import axiosHelper from '@/helpers/axiosHelper';
import ApplicationTab from '@/models/ApplicationTab';
import TabsDictionary from '@/variables/tabs';
import store from '@/store';
import eventHelper from '@/helpers/eventsHelper';
import { WatchStopHandle, watch } from 'vue';
import ItemManufacturerModel from '@/models/ItemManufacturerModel';
import ItemGroupModel from '@/models/ItemGroupModel';
import ItemModel from '@/models/ItemModel';

@Options({
	components: {
		CirclePlus, ElButton, ElTable, ElTag, ElLink
	}, 
	props: {
		params: Array
	}
})
export default class ItemsView extends Vue {
	/** params */
	params!: Array<any>;

	/** constants */
	deleteIcon = Delete;
	circleIcon = CirclePlus;
	searchIcon = Search;	
	refreshEvent = 'itemsUpdate';
	tableLoadingSvg = `<path class="path" d="M 30 15 L 28 17 M 25.61 25.61 A 15 15, 0, 0, 1, 15 30 A 15 15, 0, 1, 1, 27.99 7.5 L 15 15" style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>`;

	itemGroups = new Array<ItemGroupModel>();
	itemManufacturers = new Array<ItemManufacturerModel>();
	itemsTableHttpClient = axiosHelper.createInstance(store.getters.jwt);
	isDictionaryModeEnabled = false;

	/** view-models */
	tableLoading = false;
	tableData = new Array<ItemModel>();
	tableManufacturersFilter: Array<number> = [];
	tableGroupsFilter: Array<number> = [];
	tableSearchQuery = '';
		tableSortColumn = 'partNumber';
	tableSortOrder = 'ascending';
	tableSelectedItems = new Array<ItemModel>();
	selectedItems = new Array<number>();

	watchTableSearchQuery: WatchStopHandle | null = null;
	watchTableManufacturerFilter: WatchStopHandle | null = null;
	watchTableGroupsFilter: WatchStopHandle | null = null;

	mounted() {
		this.initViewParams();
		this.fetchManufacturersAsync();
		this.fetchGroupsAsync();

		this.watchTableSearchQuery = watch(
			() => this.tableSearchQuery,
			() => this.fetchItemsAsync()
		);

		this.watchTableManufacturerFilter = watch(
			() => this.tableManufacturersFilter,
			() => this.fetchItemsAsync()
		);

		this.watchTableGroupsFilter = watch(
			() => this.tableGroupsFilter,
			() => this.fetchItemsAsync()
		);

		eventHelper.setEventListener(this.refreshEvent, this.fetchItemsAsync);
		eventHelper.dispatchEvent(this.refreshEvent);
	}

	unmounted() {
		if (this.watchTableSearchQuery) {
			this.watchTableSearchQuery();
		}

		if (this.watchTableManufacturerFilter) {
			this.watchTableManufacturerFilter();
		}

		if (this.watchTableGroupsFilter) {
			this.watchTableGroupsFilter();
		}

		eventHelper.removeEventListener(this.refreshEvent, this.fetchItemsAsync);
	}

	initViewParams() {
		const itemsViewParams = this.params ? this.params[0] : null;

		if (!itemsViewParams) {
			return;
		}

		this.isDictionaryModeEnabled = (itemsViewParams === true);
	}

	/** fires on tables' PartNumber cell is clicked */
	onTableRowClick(row: ItemModel) {
		const addUserTab = TabsDictionary.itemView;
		addUserTab.allowMultiple = true;
		addUserTab.params = [ { item: row } ];
		store.commit('addTab', addUserTab);
		const newTab = store.getters.newlyAddedTab as ApplicationTab;
		store.commit('changeTab', newTab.id);
	}

	onAddItemClick() {
		const addItemTab = TabsDictionary.itemAdd;
		const addingNewItemView = true;
		const addingItemStrictMode = true;
		addItemTab.params = [ null, addingNewItemView, addingItemStrictMode ];
		store.commit('addTab', addItemTab);
		const newTab = store.getters.newlyAddedTab as ApplicationTab;
		store.commit('changeTab', newTab.id);
	}

	async fetchItemsAsync() {
		try {
			this.tableLoading = true;
			const filter: any = {
				orderBy: this.tableSortColumn ? this.tableSortColumn : 'id',
				orderAsc: this.tableSortOrder == 'asc' ? true : false,
				query: this.tableSearchQuery,
				groups: this.tableGroupsFilter?.join(',') ?? null,
				manufacturers: this.tableManufacturersFilter?.join(',') ?? null
			};
			const response = await this.itemsTableHttpClient.get('/api/items', { params: filter });
			if (!response.data?.length) {
				this.tableData = [];
			}

			this.tableData = response.data.map((_: any) => new ItemModel(_));
		} catch (e: any) {
			if (e.code == 'ERR_NETWORK') {
				ElNotification({
					title: 'Ошибка',
					message: 'Ошибка соединения, не удалось загрузить список запчастей',
					type: 'error',
				});
			} else {
				ElNotification({
					title: 'Ошибка',
					message: `Ошибка загрузки списка запчастей`,
					type: 'error',
				});
			}
			console.error('Error loading items list', e)
		} finally {
			this.tableLoading = false;
		}
	}

	async fetchManufacturersAsync() {
		const httpClient = axiosHelper.createInstance(store.getters.jwt);
		try {
			const response = await httpClient.get('/api/items/manufacturers');
			this.itemManufacturers = response.data;
		} catch (e) {
			console.error('Error loading items list', e)
		}
	}

	async fetchGroupsAsync() {
		const httpClient = axiosHelper.createInstance(store.getters.jwt);
		try {
			const response = await httpClient.get('/api/items/groups');
			this.itemGroups = response.data;
		} catch (e) {
			console.error('Error loading items list', e)
		}
	}

	async onDeleteItemClick(e: Event, item: ItemModel) {
		e.stopPropagation();
		ElMessageBox.confirm(
			`Запчасть '${item.partNumber}' будет удалена`,
			{
				confirmButtonText: 'OK',
				cancelButtonText: 'Отмена',
				type: 'error',
			}
		)
		.then(async () => {
			const jwt = store.getters.jwt;
			const a = axiosHelper.createInstance(jwt);
			try {
				this.tableLoading = true;
				await a.delete(`/api/items/${item.id}`);
				ElNotification({
					title: 'Запчасть удалена',
					type: 'success',
				});	
				await this.fetchItemsAsync();
				this.tableLoading = false;
			} catch (e) {			
				ElNotification({
					title: 'Ошибка, запчасть не была удалена',
					type: 'error',
				});	
				console.error(`Error deleting item #${item.id}`, e)
			} finally {
				this.tableLoading = false;
			}
		});		
	}

	/**
	 * format labels (in dropdown) of selected from table items
	 */
	formatSelectedItem(itemId: number) {
		const item = this.tableSelectedItems.find(_ => _.id == itemId);

		if (!item) {
			return '';
		}

		return `${item.externalName}, ${item.partNumber}`;
	}

	onItemSelectChange(selected: boolean, itemId: number) {
		if (selected) {
			const item = this.tableData.find(_ => _.id == itemId);
			if (!item) {
				return;
			}
			this.tableSelectedItems.push(item);
			this.selectedItems.push(item.id);
		} else {			
			const tableSelectedItemIndex = this.tableSelectedItems.findIndex(_ => _.id == itemId);

			if (tableSelectedItemIndex < 0) {
				return;
			}

			this.tableSelectedItems = this.tableSelectedItems.slice(tableSelectedItemIndex, tableSelectedItemIndex);
			const selectedItemIndex = this.selectedItems.findIndex(_ => _ == itemId);

			if (selectedItemIndex < 0) {
				return;
			}

			this.selectedItems = this.selectedItems.slice(selectedItemIndex, selectedItemIndex);
		}
	}

	onSaveItemsSetClick() {
		console.log(this.selectedItems);
	}

	onClearItemsSetClick() {
		this.tableSelectedItems = new Array<ItemModel>();
		this.selectedItems = new Array<number>();
	}

	onTableSortingChange(a: any) {
		this.tableSortColumn = a.prop ?? null;
		this.tableSortOrder == a.order;
		this.fetchItemsAsync();
	}
}
</script>